<template>
  <div
    class="chat-header"
    ref="chatHeaderContainer"
  >
    <v-row mb6>
      <v-col>
        <span class="titulo">{{ titulo ? mostrarTiuloIncidencia(titulo) : '' }}</span>
      </v-col>
      <!-- <v-col>
        <span class="icono" @click="descargarLogCsv()"><v-icon  slot="divider" :title="$t('descargar')">vertical_align_bottom</v-icon></span>
      </v-col> -->
      <v-col>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="primary"
              class="icono"
              v-on="on"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="descargarLogTxt()">
              <v-list-item-content>
                <v-list-item-title>
                  {{$t('descargar') + ' .txt'}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider/>
            <v-list-item @click="descargarLogCsv()">
              <v-list-item-content>
                <v-list-item-title>
                  {{$t('descargar') + ' .csv'}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
   <hr>
  </div>
</template>

<script>

import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'chat-header',
  props: {
    titulo: String,
    idIncidencia: String
  },
  data () {
    return {

    }
  },
  watch: {

  },
  mounted () {

  },
  computed: {
    ...mapGetters({
      getChat: 'chat/getChat'
    }),
    chatFormatedTxt () {
      return this.getChat.map(x => {
        return '[' + x.FECHA_ENVIO + ' - ' + x.ID_ACTOR + ']: ' + x.TEXTO_MENSAJE
      })
    },
    chatFormatedCsv () {
      return [['FECHA ENVIO', 'ID ACTOR', 'MENSAJE', 'HASH ANTERIOR', 'HASH PROPIO',]].concat(this.getChat.map(x => {
        return [x.FECHA_ENVIO, x.ID_ACTOR, x.TEXTO_MENSAJE, x.HASH_ANTERIOR, x.HASH_PROPIO]
      }))
    }
  },
  methods: {
    ...mapActions({
      descargarChat: 'chat/descargarChat'
    }),
    async descargarLogTxt () {
      // const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      await this.descargarChat(this.idIncidencia)
      let element = document.createElement('a')
      // element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.chatFormatedTxt))
      element.setAttribute('href', 'data:text/plain;base64,' + window.btoa(unescape(encodeURIComponent(this.chatFormatedTxt.join('\r\n')))))
      element.setAttribute('download', 'Chat')
      document.body.appendChild(element)
      element.click()
    },
    async descargarLogCsv () {
      // const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      await this.descargarChat(this.idIncidencia)
      let csv = encodeURI('data:text/csv;charset=utf-8,' + this.chatFormatedCsv.map(e => e.join(",")).join("\r\n"))
      let element = document.createElement('a')
      element.setAttribute('href', csv)
      element.setAttribute('download', 'Chat')
      document.body.appendChild(element)
      element.click()
    },
    mostrarTiuloIncidencia (titulo) {
      return (titulo.length > 50) ? titulo.substr(0, 50) : titulo
    }
  }
}
</script>

<style scoped>
.chat-header {
  display: block;
  height: 60px;
  width: 100%;
  box-sizing: border-box;
}
.chat-header-container {
  display: block;
  height: 58px;
  width: 100%;
  padding-right: 20px;
  padding-top: 20px;
  box-sizing: border-box;
}

.titulo {
  padding-left: 2%;
}
.icono {
  float:right;
  padding-right: 2%;
  cursor: pointer;
}
.chat-header::-webkit-scrollbar {
  display: none;
}
</style>
